<template>
  <legal-page>
    <h1>注销账号须知</h1>

    <ol>
      <li>注销申请仅限账号本人操作，我们可能通过登录密码、绑定手机号验证码等已有方式核验身份。</li>
      <li>提交注销前，请确认账号不存在未完成的订单、提现、授权、申诉或其他待处理业务。</li>
      <li>请提前处理账号中的宇宙币及其他虚拟资产。注销完成后，未使用的非现金权益将失效且无法恢复；涉及充值余额的，应先通过提现等处理方式提前处理。</li>
      <li>请提前解除不再需要的微信、手机号或其他第三方账号绑定。</li>
      <li>账号注销完成后，账号资料、使用记录、个人设置、已创建内容及相关权益将无法恢复。</li>
      <li>我们将在收到有效申请后尽快处理，建议明确承诺“3个工作日内完成”。处理期间用户可以通过客服查询注销进度。</li>
      <li>注销完成后，我们将删除账号相关个人信息或进行匿名化处理。法律法规要求继续保存的信息，仅在规定期限内保存，并停止用于日常业务。<a href="https://www.npc.gov.cn/WZWSREL25wYy9jMzA4MzQvMjAyMTA4L3QyMDIxMDgyMF8zMTMwODguaHRtbD9yZWY9aW1i" target="_blank" rel="noopener noreferrer">《个人信息保护法》第四十七条</a></li>
      <li>依法需要保存的交易、投诉、争议处理、安全风控和违法违规记录，不因账号注销而提前删除。</li>
      <li>注销成功后，当前账号将退出所有设备且不能继续登录。以后使用相同手机号重新注册，将被视为新账号，原账号数据和权益不会恢复。</li>
      <li>如账号无法正常注销，请联系客服或者问题反馈。</li>
    </ol>
  </legal-page>
</template>

<script>
import LegalPage from '@/components/main/legal/LegalPage'

export default {
  name: 'AccountCancellation',
  components: {
    LegalPage
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/accountCancellation.vue